var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useToast } from '@stores/toast';
import StyledToastLayer from './ToastLayer.style';
/**
 * 플레이어 등에서 사용 되는 Common Toast Layer
 * toast store를 통해 text 및 timeout 을 세팅하여 노출한다.
 * @constructor
 */
var ToastLayer = function () {
    var toastLayerRef = useRef(null);
    var _a = __read(useToast(function (state) { return [state.toasts, state.removeToast]; }), 2), toasts = _a[0], removeToast = _a[1];
    var toast = toasts.length > 0 ? toasts[0] : undefined;
    var handleTransitionend = function (e) {
        if (e.target.style.opacity === '1') {
            e.target.style.opacity = '0';
        }
        else {
            if (toastLayerRef === null || toastLayerRef === void 0 ? void 0 : toastLayerRef.current) {
                toastLayerRef.current.style.visibility = 'hidden';
            }
            removeToast();
        }
    };
    useEffect(function () {
        if (toastLayerRef === null || toastLayerRef === void 0 ? void 0 : toastLayerRef.current) {
            toastLayerRef.current.style.visibility = 'visible';
            toastLayerRef.current.style.opacity = '1';
        }
        // 방어코드 : 트렌지션엔드가 안먹었을 경우 한번더 죽여주는 방어 코드 삽입
        var toastSetTimeOut = setTimeout(function () {
            if (toastLayerRef === null || toastLayerRef === void 0 ? void 0 : toastLayerRef.current) {
                toastLayerRef.current.style.opacity = '0';
            }
        }, 2500);
        return function () {
            clearTimeout(toastSetTimeOut);
            if (toastLayerRef === null || toastLayerRef === void 0 ? void 0 : toastLayerRef.current) {
                toastLayerRef.current.style.opacity = '0';
            }
        };
    }, [toast]);
    return toast ? (_jsx(StyledToastLayer, __assign({ className: "ToastLayer", ref: toastLayerRef, onTransitionEnd: handleTransitionend, toast: toast }, { children: _jsx("p", { children: toast === null || toast === void 0 ? void 0 : toast.text }) }))) : null;
};
export default ToastLayer;
